export default __webpack_public_path__ + "static/media/treyd_square_logo_white.99838cc3.svg";